import { Progress } from "@/components/ui/progress";

interface AIProgressBarProps {
  progress: number;
  isAnalyzing?: boolean;
  type?: 'document' | 'ai-help';
}

export function AIProgressBar({ progress, isAnalyzing, type = 'document' }: AIProgressBarProps) {
  if (progress === 0 && !isAnalyzing) return null;

  const messages = {
    document: {
      analyzing: "Analyserer dokument...",
      preparing: "Forbereder...",
      generating: "Genererer innhold...",
      finishing: "Fullfører...",
      done: "Ferdig!"
    },
    'ai-help': {
      analyzing: "Analyserer forespørsel...",
      preparing: "Forbereder AI-assistanse...",
      generating: "Genererer AI-hjelp...",
      finishing: "Fullfører...",
      done: "AI-hjelp er klar!"
    }
  };

  return (
    <div className="px-4 py-2">
      <Progress value={isAnalyzing ? 50 : progress} className="w-full" />
      <p className="text-sm text-muted-foreground mt-1">
        {isAnalyzing && messages[type].analyzing}
        {!isAnalyzing && progress === 25 && messages[type].preparing}
        {!isAnalyzing && progress === 50 && messages[type].generating}
        {!isAnalyzing && progress === 75 && messages[type].finishing}
        {!isAnalyzing && progress === 100 && messages[type].done}
      </p>
    </div>
  );
}